<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <contadores
      :total="contadores.total"
      :ativos="contadores.ativos"
      :inativos="contadores.inativos"
      @alterarFiltro="atualizarFiltro"
    />

    <configurar-associacao-fila-formulario-dialog
      :is-configurar-associacao-fila-formulario-dialog-open.sync="isConfigurarAssociacaoFilaFormularioDialogOpen"
      :ordens-permitidas="ordensPermitidas"
      @refetch-data="getFilaFormularios"
    />

    <v-card class="d-flex justify-space-between">
      <v-card-title>Formulários</v-card-title>

      <v-btn
        v-if="!acessoPost"
        color="primary"
        class=" ma-3"
        disabled
      >
        <span>Adicionar</span>
      </v-btn>

      <v-btn
        v-else
        color="primary"
        class=" ma-3"
        @click="isConfigurarAssociacaoFilaFormularioDialogOpen = !isConfigurarAssociacaoFilaFormularioDialogOpen"
      >
        <span>Adicionar</span>
      </v-btn>
    </v-card>

    <div style="min-height: 4px">
      <v-progress-linear
        v-if="loading"
        indeterminate
        @refetch-data="getFilaFormularios"
      />
    </div>

    <table-associacao-fila-formulario
      :items="filaFormularios"
      :acesso-disable="acessoDisable"
      :is-configurar-associacao-fila-formulario-dialog-open.sync="isConfigurarAssociacaoFilaFormularioDialogOpen"
      @refetch-data="getFilaFormularios"
    />
  </v-card>
</template>

<script>
import { ref, onMounted, computed } from '@vue/composition-api'
import { mapState } from 'pinia'
import ConfigurarAssociacaoFilaFormularioDialog from './ConfigurarAssociacaoFilaFormularioDialog.vue'
import TableAssociacaoFilaFormulario from './TableAssociacaoFilaFormulario.vue'
import Contadores from '@/components/contadores/Contadores.vue'
import router from '@/router'
import FilaService from '@/services/modules/FilaService'
import useAuthStore from '@/store/auth'

export default {
  components: {
    TableAssociacaoFilaFormulario,
    ConfigurarAssociacaoFilaFormularioDialog,
    Contadores,
  },

  data() {
    return {
      idPost: 2066,
      acessoPost: true,
      idDisable: 2067,
      acessoDisable: true,
    }
  },

  computed: {
    ...mapState(useAuthStore, ['funcionalidades']),
  },

  mounted() {
    // this.permissoes()
  },

  methods: {
    permissoes() {
      if (!this.funcionalidades.includes(this.idPost)) {
        this.acessoPost = false
      }
      if (!this.funcionalidades.includes(this.idDisable)) {
        this.acessoDisable = false
      }
    },
  },

  setup() {
    const isConfigurarAssociacaoFilaFormularioDialogOpen = ref(false)

    // Todos (ativos + inativos) alimenta a validacao de ordem; filaFormularios (filtrado) alimenta a tabela.
    const filaFormulariosTodos = ref([])
    const filaFormularios = ref([])
    const filtroStatus = ref('true')
    const contadores = ref({ total: 0, ativos: 0, inativos: 0 })
    const loading = ref(false)

    function aplicarFiltro() {
      contadores.value.total = filaFormulariosTodos.value.length
      contadores.value.ativos = filaFormulariosTodos.value.filter(it => it.ativo).length
      contadores.value.inativos = filaFormulariosTodos.value.filter(it => !it.ativo).length

      filaFormularios.value = filtroStatus.value
        ? filaFormulariosTodos.value.filter(it => it.ativo.toString() === filtroStatus.value)
        : filaFormulariosTodos.value
    }

    async function getFilaFormularios() {
      try {
        loading.value = true
        filaFormulariosTodos.value = await FilaService.getFilaFormularios(router.currentRoute.params.id)
        aplicarFiltro()
      } finally {
        loading.value = false
      }
    }
    onMounted(getFilaFormularios)

    function atualizarFiltro(item) {
      filtroStatus.value = item
      aplicarFiltro()
    }

    const ordensPermitidas = computed(() => Array.from({ length: filaFormulariosTodos.value.filter(it => !!it.formularioId).length + 1 }, (_, index) => index + 1))

    return {
      isConfigurarAssociacaoFilaFormularioDialogOpen,
      filaFormularios,
      contadores,
      atualizarFiltro,
      loading,
      getFilaFormularios,
      ordensPermitidas,
    }
  },
}
</script>
